module.exports = __webpack_public_path__ + "static/img/preview-blue-no-progress-bar.2c71e063.png";